import { Order as OrderTypes } from '@luxuryescapes/contract-svc-order'

function merchandiseShippingItemMap(item: OrderTypes.MerchandiseShippingItem): App.OrderMerchndiseShippingItem {
  return {
    id: item.id,
    total: item.total,
    status: item.status,
    shippingGroupId: item.shipping_group,
    address: {
      firstName: item.address?.firstName ?? '',
      lastName: item.address?.lastName ?? '',
      company: item.address?.company ?? '',
      address: item.address?.address ?? '',
      address2: item.address?.address2,
      city: item.address?.city ?? '',
      state: item.address?.state ?? '',
      postcode: item.address?.postcode ?? '',
      country: item.address?.country ?? '',
      phone: item.address?.phone ?? '',
    },
  }
}

export default merchandiseShippingItemMap
